import React, { useState } from 'react';
import { Card, Breadcrumb, Input, Row, Col, List, Space, Button, Spin } from 'antd';
import Background from '../../../../static/img/bg-list-title.png';
import { queryCompanyList } from './gqls'
import Client from '../../../../lib/gqlClient';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
const CompanyList = (props) => {
    const navigate = useNavigate();
    const location = useLocation()
    const { state } = location
    const [seatchData, setSeatchData] = useState('')
    const [isGetData, setIsGetData] = useState(false)
    const [total, setTotal] = useState(1)
    const [dataList, setDataList] = useState([])
    const [showSize, setShowSize] = useState(8)
    const [page, setPage] = useState(1)
    React.useEffect(() => {
        if (state != null) {
            setSeatchData(state.seatchData)
            setPage(state.page)
            setShowSize(state.showSize)
            getCompanyList(state.seatchData, state.page, state.showSize)
        }else{
            onSearch()
        }
    }, [])
    function onInPut(value) {
        console.log(value.target.value);
        setSeatchData(value.target.value)
    }
    function onSearch() {
        getCompanyList(seatchData, page, showSize)

    }
    function getCompanyList(value, page, count) {
        if (count !== showSize) {
            setShowSize(count)
        }

        setIsGetData(true)
        Client(
            queryCompanyList,
            {
                name: value,
                page: page,
                count: count
            }
        ).then((res) => {
            if (res !== null) {
                setDataList(res.data.companyList.data)
                setTotal(res.data.companyList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }

    function onClick(id, type) {
        if (type === 'app') {
            navigate('/developerCenter/companyList/appUsage', { replace: false, state: { appId: id } })

        } else {
            navigate('/developerCenter/companyList/companyUsage', {
                replace: false, 
                state: {
                    companyId: id,
                    seatchData: seatchData,
                    page: page,
                    showSize: showSize
                }
            })
        }


    }
    function onStart() {
        props.setNewKey('developerCenter/dataNotification')
        navigate('/developerCenter/dataNotification')

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>

            {/* 标题头 */}
            <div style={{ height: '200px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>SDK Dashboard</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>公司列表</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={Styles.title}>搜索公司</div>

                <Row style={Styles.search}>
                    <Col>
                        <div >
                            <Input
                                placeholder="请输入 Company Name\ Master Developer email address"
                                size="large"
                                style={{
                                    width: '556px',
                                    borderRadius: '2px',
                                    height: '46px'
                                }}
                                onChange={onInPut}
                                onPressEnter={onSearch}
                            />
                        </div></Col>
                    <Col>
                        <Button style={{ padding: '0px', height: '46px', width: '80px', background: '#FF5300', color: 'white' }} onClick={onSearch}>搜索</Button>
                    </Col>
                </Row>

            </div>


            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>公司列表</div>
                <Row style={Styles.listTitleBg}>
                    <Col span={6} style={Styles.listTitleText}>
                        Company Name
                    </Col>
                    <Col span={6} style={Styles.listTitleText}>
                        Master Developer
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Region
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        Country
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        Status
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Operation
                    </Col>
                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData}>

                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page) => {
                                setPage(page)
                                getCompanyList(seatchData, page, showSize)
                            },
                            current: page,
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions: [8, 10, 15, 20, 30, 50, 80, 100],
                            onShowSizeChange: (current, pageSize) => {
                                getCompanyList(seatchData, current, pageSize)
                            },
                            total: total

                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item) => (
                            <List.Item>
                                <Row style={Styles.item}>
                                    <Col span={6} style={Styles.listTitleText}>
                                        {item.company}
                                    </Col>
                                    <Col span={6} style={Styles.listTitleText}>
                                        {item.developerEmail}
                                    </Col>
                                    <Col span={2} style={Styles.listTitleText}>
                                        {item.region}
                                    </Col>
                                    <Col span={3} style={Styles.listTitleText}>
                                        {item.nationality}
                                    </Col>
                                    <Col span={3} style={Styles.listTitleText}>
                                        Active
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        {/* <a onClick={() => this.onClick(item._id,'app')}>
                                        <Space>
                                        App Usage
                                        </Space>
                                    </a>
                                    <div> */}
                                        <a onClick={() => onClick(item._id, 'company')}>
                                            <Space>
                                                Company Usage
                                            </Space>
                                        </a>
                                        {/* </div> */}
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Spin>
            </Card>

        </div>
    );

}

const { Search } = Input;
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    search: {
        color: '#2D3238',
        height: '46px',
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        marginTop: '30px'
    },
    listTitleText: {
        fontSize: '14px',
        lineHeight: '22px',
        textAlign: 'center',
        marginTop: '16px'
    },
    item: {
        height: '54px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
    },
}
export default CompanyList